
const ConfirmationModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Please Confirm",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel"
}) => {
  if (!isOpen) {
    return null;
  }

  return (
    <>
      {/* Overlay */}
      <div 
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
        onClick={onClose}
      />
      
      {/* Modal Content */}
      <div 
        style={{
          position: "fixed",
          top: "35%",
          padding: "40px 50px",
          zIndex: 1000,
          border: "1px solid #ffffff33",
          backgroundColor: "#1a1a1a",
          borderRadius: "8px",
          minWidth: "400px"
        }}
      >
        <h2 style={{
          fontFamily: "Manrope, sans-serif",
          fontWeight: 800,
          fontSize: "1.2rem",
          color: "white",
          marginTop: "0.5rem",
          marginBottom: "1rem"
        }}>
          {title}
        </h2>
        
        <p style={{
          width: "25rem",
          fontFamily: "Manrope, sans-serif",
          fontWeight: 400,
          marginTop: "1rem",
          fontSize: "0.9rem",
          color: "white"
        }}>
          {message}
        </p>
        
        <div style={{
          display: "flex",
          padding: "0.5rem",
          gap: "1rem",
          justifyContent: "flex-end",
          marginTop: "1rem"
        }}>
          <button 
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#374151",
              color: "white",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 500
            }}
            onClick={onClose}
            onMouseOver={(e) => e.target.style.backgroundColor = "#4b5563"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#374151"}
          >
            {cancelText}
          </button>
          
          <button
            style={{
              padding: "0.5rem 1.5rem",
              backgroundColor: "#413CAA",
              color: "white",
              border: "none",
              borderRadius: "12px",
              cursor: "pointer",
              fontFamily: "Manrope, sans-serif",
              fontWeight: 500
            }}
            onClick={onConfirm}
            onMouseOver={(e) => e.target.style.backgroundColor = "#332F88"}
            onMouseOut={(e) => e.target.style.backgroundColor = "#413CAA"}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </>
  );
};

export default ConfirmationModal;